import React, { useEffect, useState } from 'react';
import Spinner from '../SalesData/Spinner';

const formatElapsed = (ms) => {
    const seconds = Math.floor(ms / 1000);
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
};

const Elapsed = ({ startedAt }) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, []);

    return <span style={{ color: '#666' }}> ({formatElapsed(now - startedAt)})</span>;
};

const ActionStatus = ({ status, message, error, startedAt }) => {
    if (status === 'idle') return null;

    if (status === 'running') {
        return (
            <div style={{ padding: '0.75rem 0 0' }}>
                <Spinner />Pågår<Elapsed startedAt={startedAt} />
            </div>
        );
    }

    const succeeded = status === 'succeeded';
    return (
        <div
            role="status"
            style={{
                margin: '0.75rem 0 0',
                padding: '0.5rem 0.75rem',
                borderRadius: '0.25rem',
                color: succeeded ? '#1b6e2d' : '#b3261e',
                backgroundColor: succeeded ? '#e3f4e7' : '#fde7e5',
                whiteSpace: 'pre-wrap',
            }}
        >
            {succeeded ? message || 'Klart' : `Fel: ${error || 'Okänt fel'}`}
        </div>
    );
};

export default ActionStatus;
